<!--status === null || documentId === null is the same as AnnualStatementStatus.Expected || status === AnnualStatementStatus.NotReceived-->

<div class="action-container" *appHasRole="['Admin', 'Manager', 'Preparer']">
  @if (status === null || documentId === null) {
    <a [routerLink]="companyProfilePath">
      <app-ag-action-icon-button iconClass="ic-eye-16"/>
    </a>
  }

  <app-ag-action-icon-button
    iconClass="ic-send-16"
    tooltipText="View and Send"
    [disabled]="isViewAndSendDisabled"
    (action)="send()"
  />

  @if (status !== null && documentId !== null) {
    <a [routerLink]="annualStatementEditPath">
      <app-ag-action-icon-button
        iconClass="ic-edit-16"
        tooltipText="Customise and Send"
        [disabled]="isCustomiseAndSendDisabled"
      />
    </a>
  }

  @if (pageFilter !== AnnualStatementPageFilter.Expected) {
    <div
      ngbDropdown
      [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
      class="dropdown d-inline-flex"
      container="body"
    >
      <app-ag-action-icon-button
        ngbDropdownToggle
        iconClass="ic-more-horizontal-16"
        [disabled]="!menuActions.length"
      />

      <div ngbDropdownMenu class="common-dropdown-menu dropdown-menu dropdown-menu-right">
        @for (item of menuActions; track $index) {
          <div ngbDropdownItem class="dropdown-item" (click)="item.action()">
            <i class="{{item.iconClass}}"></i>
            <span>{{ item.title }}</span>
          </div>
        }
      </div>
    </div>
  }
</div>
